<script>
  import swiper, { Lazy, Pagination, Scrollbar, Navigation } from "swiper";
  import ProductCard from './ProductCard.svelte';
  import GhostCard from './GhostCard.svelte';
  import Icon from './Icon.svelte';
  import { isLoading, viewAllBgColour, viewAllButton, getCollectionFromStorefront } from './stores/activeCollection.js';
  import { onMount } from 'svelte';

  export let spacing;
  export let collectionHandle;
  export let productHandle;
  export let maxProducts;
  export let viewAllBackground;
  export let viewAllButtonColour;

  let products;

  onMount(async () => {
    products = await getCollectionFromStorefront(collectionHandle, maxProducts);
  })

  function setUpCarousel(node) {
    return new swiper(node, {
      modules: [Lazy, Pagination, Scrollbar, Navigation],
      slidesPerView: 1.2,
      spaceBetween: 15.5,
      lazy: true,

      scrollbar: {
        el: '.product-carousel .slider-scrollbar',
        draggable: true,
        hide: false,
        snapOnRelease: false,
        dragSize: 80,
      },
      breakpoints: {
            // when window width is >= 1024px
            1024: {
              slidesPerView: 4.15,
              navigation: {
                nextEl: '.product-carousel .swiper-button-next',
                prevEl: '.product-carousel .swiper-button-prev',
              },
              scrollbar: {
                dragSize: 240,
              },
            }
          }
    })
  }
</script>

<div use:setUpCarousel class={`swiper ${spacing} relative product-carousel swiper-container wrapper-right`}>
  <ul class="swiper-wrapper mb-5 md:mb-10 flex flex-row">
    {#if products}
      {#each products as product, i}
        {#if $isLoading}
          <GhostCard />
        {:else}
          {#if product.node.handle != productHandle}
            {#if i < 8 }
              <ProductCard {product} />
            {/if}
          {/if}
        {/if}
      {/each}

      {#if products.length > 7 }
        <div class="{viewAllBackground.includes('#') ? '' : viewAllBackground} flex items-center carousel-view-all swiper-slide"
            style="{viewAllBackground.includes('#') ? `background-color: ${viewAllBackground}` : ''}"
        >
          <a class="btn block w-[135px] cursor-pointer m-auto {viewAllButtonColour}" href="/collections/{collectionHandle}">View all</a>
        </div>
      {/if}
    {/if}
  </ul>

  <button class={`swiper-button-next hidden lg:flex items-center justify-center w-5 h-5 bg-brand-white text-[#3b7f8a] rounded-full absolute right-4 top-[32vw] lg:top-[12vw] z-10 cursor-pointer p-1`} aria-label="Previous Slide">
    <Icon icon="arrow" />
  </button>
  <button class={`swiper-button-prev hidden lg:flex items-center justify-center w-5 h-5 bg-white text-brand-blue rounded-full absolute left-4 top-[32vw] lg:top-[12vw] z-10 cursor-pointer p-1`} aria-label="Next Slide">
    <Icon icon="arrow" />
  </button>
  <div class="slider-scrollbar w-full max-w-[250px] md:max-w-[480px] mx-auto"></div>
</div>
